var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDraw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#6415ff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126-86v-175l583-582q14-14 31.5-22.5T775-874q18 0 35.5 8.5T843-843l42 40q14 14 21.5 31t7.5 35q0 17-7 34.5T885-670L302-86H126Zm96-95h40l412-412-20-21-20-20-412 413v40Zm595-555-41-41 41 41ZM654-614l-20-20 40 41-20-21ZM540-86q77 0 142.5-39T748-234q0-38-19-65.5T676-347l-70 71q23 9 35 20t12 22q0 20-34.5 36.5T540-181q-20 0-33.5 13.5T493-134q0 20 13.5 34T540-86ZM184-433l76-76q-40-8-59.5-17T181-546q0-9 15.5-21t74.5-33q91-33 120.5-65.5T421-746q0-59-45.5-93.5T254-874q-46 0-83.5 16.5T113-816q-12 16-10.5 34.5T120-750q15 12 33.5 10.5T186-755q12-12 28.5-18t39.5-6q37 0 54.5 10t17.5 23q0 14-17 25.5T233-687q-86 32-116.5 64.5T86-546q0 43 24 68.5t74 44.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraw);
export default __webpack_public_path__ + "static/media/draw.56de7e9e2f20ee3e0f474abcb59752d1.svg";
export { ForwardRef as ReactComponent };